import axios from 'axios';
export const jsonApiHeaders = {
  'content-type': 'application/json',
};
export const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
